/* DIREVULF — wishlist.
   ------------------------------------------------------------------------
   WHAT IS STORED, AND WHY SO LITTLE
   Only what is needed to show the item again and to detect a real change:
   the product id, its handle, and a snapshot of the price and availability at
   the moment it was saved. Nothing about the customer is written here — no
   name, no email, no address, no order. localStorage is readable by anything
   running on this origin, so it holds catalogue facts and nothing else.

   HONEST CHANGE DETECTION
   "Price dropped" or "back in stock" is only ever shown when there is a real
   stored before and a freshly fetched after, and they genuinely differ. There
   is no invented "3 things changed" badge: the number is counted from actual
   differences, and when nothing changed nothing is said.

   LOGGED-IN SYNC
   Server-side persistence needs a backend this theme deliberately does not
   have. The seam is DirevulfWishlist.adapter — replace the default local
   adapter with one that talks to an App Proxy and every call site keeps
   working. Until then a guest wishlist is what exists, and the page says so
   rather than implying an account sync that is not running.
   ------------------------------------------------------------------------ */
(function () {
  'use strict';

  var KEY = 'dv:wishlist';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* --------------------------------------------------------------- storage */
  var localAdapter = {
    read: function () {
      try {
        var raw = window.localStorage.getItem(KEY);
        var list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
      } catch (e) { return []; }
    },
    write: function (list) {
      try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
      return list;
    }
  };

  var Wishlist = {
    adapter: localAdapter,

    list: function () { return Wishlist.adapter.read(); },
    count: function () { return Wishlist.list().length; },

    has: function (id) {
      id = String(id);
      return Wishlist.list().some(function (entry) { return String(entry.id) === id; });
    },

    add: function (entry) {
      if (!entry || !entry.id) return Wishlist.list();
      var list = Wishlist.list().filter(function (e) { return String(e.id) !== String(entry.id); });
      list.unshift({
        id: String(entry.id),
        handle: entry.handle || '',
        /* Snapshot, in the shop's own minor units — never formatted, never a
           string the customer sees. Formatting always happens in Liquid. */
        price: typeof entry.price === 'number' ? entry.price : null,
        available: typeof entry.available === 'boolean' ? entry.available : null,
        saved_at: Date.now()
      });
      return Wishlist.adapter.write(list);
    },

    remove: function (id) {
      id = String(id);
      return Wishlist.adapter.write(Wishlist.list().filter(function (e) { return String(e.id) !== id; }));
    },

    clear: function () { return Wishlist.adapter.write([]); },

    toggle: function (entry) {
      var on = !Wishlist.has(entry.id);
      if (on) Wishlist.add(entry); else Wishlist.remove(entry.id);
      Wishlist.render();
      document.dispatchEvent(new CustomEvent('dv:wishlist:change', { detail: { id: entry.id, saved: on } }));
      return on;
    },

    /* ------------------------------------------------------------- display */
    render: function () {
      var n = Wishlist.count();
      $$('[data-dv-wishlist-count]').forEach(function (node) {
        node.textContent = n > 0 ? String(n) : '';
        node.hidden = n === 0;
      });
      $$('[data-dv-wishlist-toggle]').forEach(function (btn) {
        var saved = Wishlist.has(btn.getAttribute('data-product-id'));
        btn.setAttribute('aria-pressed', String(saved));
        btn.classList.toggle('is-saved', saved);
        var label = saved ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
        if (label) btn.setAttribute('aria-label', label);
        var text = $('[data-dv-wishlist-text]', btn);
        var textSaved = btn.getAttribute('data-text-saved');
        var textAdd = btn.getAttribute('data-text-add');
        if (text && textSaved && textAdd) text.textContent = saved ? textSaved : textAdd;
      });
    }
  };

  window.DirevulfWishlist = Wishlist;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-dv-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    var price = parseInt(btn.getAttribute('data-product-price'), 10);
    Wishlist.toggle({
      id: btn.getAttribute('data-product-id'),
      handle: btn.getAttribute('data-product-handle'),
      price: isNaN(price) ? null : price,
      available: btn.getAttribute('data-product-available') === 'true'
    });
  });

  /* Another tab changed the list — keep this one honest. */
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) Wishlist.render();
  });

  /* ------------------------------------------------------------ the page */
  /* Every saved item is re-rendered by LIQUID through the Section Rendering
     API (/products/<handle>?section_id=wishlist-card), so the card, the price
     and the sold-out state are exactly what the storefront would show — and
     the price goes through the money filter, which is the only way ₹ is ever
     guaranteed. No money is formatted in JavaScript anywhere in this file.

     That same response carries data-price and data-available, which is all the
     comparison against the saved snapshot needs. */
  /* The signed-out gate. Liquid renders the neutral heading because it cannot
     see this device's saved list; if there IS something saved here, the
     heading becomes the one that says so. Telling a shopper their list is
     empty when their own browser is holding four things is the kind of small
     untruth they can disprove in one click. */
  function initGate() {
    var gate = $('[data-dv-wishlist-gate]');
    if (!gate) return true;
    if (!Wishlist.count()) return true;

    var title = $('.dv-gate__title', gate);
    var text = $('.dv-gate__text', gate);
    if (title && gate.getAttribute('data-title-holding')) {
      title.textContent = gate.getAttribute('data-title-holding');
    }
    if (text && gate.getAttribute('data-text-holding')) {
      text.textContent = gate.getAttribute('data-text-holding');
    }
    return true;
  }

  function initPage() {
    var page = $('[data-dv-wishlist-page]');
    if (!page) return;
    /* Signed out: the gate is what this page is, and there is no grid to
       fill, so nothing below runs. */
    if ($('[data-dv-wishlist-gate]', page)) return;

    var grid = $('[data-dv-wishlist-grid]', page);
    var emptyState = $('[data-dv-wishlist-empty]', page);
    var loading = $('[data-dv-wishlist-loading]', page);
    var errorBox = $('[data-dv-wishlist-error]', page);
    var changes = $('[data-dv-wishlist-changes]', page);
    var changesList = $('[data-dv-wishlist-changes-list]', page);
    var tools = $('[data-dv-wishlist-tools]', page);
    var cardSection = page.getAttribute('data-card-section') || 'wishlist-card';
    var tabs = $('[data-dv-wishlist-tabs]', page);
    var activeTab = 'all';

    var strings = {};
    var stringNode = $('[data-dv-wishlist-strings]', page);
    if (stringNode) { try { strings = JSON.parse(stringNode.textContent); } catch (e) { strings = {}; } }

    function show(node, on) { if (node) node.hidden = !on; }

    function fetchCard(handle) {
      var url = ROOT.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(cardSection);
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .catch(function () { return null; });
    }

    function describeChange(entry, node) {
      var priceAttr = node.getAttribute('data-price');
      var availAttr = node.getAttribute('data-available');
      var nowPrice = priceAttr === null ? null : parseInt(priceAttr, 10);
      var nowAvailable = availAttr === null ? null : availAttr === 'true';

      if (entry.price != null && nowPrice != null && !isNaN(nowPrice) && nowPrice !== entry.price) {
        return nowPrice < entry.price ? 'price_down' : 'price_up';
      }
      if (entry.available === false && nowAvailable === true) return 'back_in_stock';
      if (entry.available === true && nowAvailable === false) return 'sold_out';
      return null;
    }

    /* ------------------------------------------------------------- tabs */
    /* A tab exists only for a change that actually happened to a saved item.
       The counts are card counts. Nothing is shown when nothing changed. */
    function paintTabs(counts, total) {
      if (!tabs) return;
      var any = false;
      $$('[data-dv-wishlist-tab]', tabs).forEach(function (button) {
        var kind = button.getAttribute('data-dv-wishlist-tab');
        var n = kind === 'all' ? total : (counts[kind] || 0);
        var out = $('[data-dv-tab-count]', button);
        if (out) out.textContent = n ? String(n) : '';
        if (kind === 'all') return;
        button.hidden = !n;
        if (n) any = true;
      });
      tabs.hidden = !any;
      if (!any) activeTab = 'all';
      selectTab(activeTab);
    }

    function selectTab(kind) {
      activeTab = kind;
      if (tabs) {
        $$('[data-dv-wishlist-tab]', tabs).forEach(function (button) {
          var mine = button.getAttribute('data-dv-wishlist-tab') === kind;
          button.classList.toggle('is-active', mine);
          button.setAttribute('aria-selected', String(mine));
        });
      }
      if (!grid) return;
      $$('.dv-wish__item', grid).forEach(function (item) {
        var card = item.firstElementChild;
        var changed = card ? card.getAttribute('data-changed') : null;
        item.hidden = kind !== 'all' && changed !== kind;
      });
    }

    function load() {
      var entries = Wishlist.list().filter(function (e) { return e.handle; });
      show(errorBox, false);

      if (!entries.length) {
        show(loading, false);
        show(grid, false);
        show(tools, false);
        show(changes, false);
        show(tabs, false);
        show(emptyState, true);
        return;
      }

      show(emptyState, false);
      show(changes, false);
      show(loading, true);
      show(grid, false);

      Promise.all(entries.map(function (entry) { return fetchCard(entry.handle); }))
        .then(function (htmls) {
          grid.innerHTML = '';
          var changed = [];
          var counts = {};
          var kept = 0;

          htmls.forEach(function (html, i) {
            var entry = entries[i];
            if (!html) {
              /* The product is gone from the storefront. Drop it rather than
                 leave a broken card behind. */
              Wishlist.remove(entry.id);
              return;
            }
            var holder = document.createElement('div');
            holder.innerHTML = html;
            var card = holder.querySelector('[data-dv-wishlist-card]');
            if (!card) { Wishlist.remove(entry.id); return; }

            var kind = describeChange(entry, card);
            if (kind) {
              var title = card.getAttribute('data-title') || '';
              changed.push({ title: title, kind: kind });
              counts[kind] = (counts[kind] || 0) + 1;
              card.setAttribute('data-changed', kind);
            }

            var li = document.createElement('li');
            li.className = 'dv-wish__item';
            li.appendChild(card);
            grid.appendChild(li);
            kept += 1;
          });

          show(loading, false);

          if (!kept) {
            show(grid, false);
            show(tools, false);
            show(tabs, false);
            show(emptyState, true);
            return;
          }

          if (changed.length && changes && changesList) {
            changesList.innerHTML = '';
            changed.forEach(function (c) {
              var li = document.createElement('li');
              li.textContent = c.title + ' — ' + (strings['change_' + c.kind] || '');
              changesList.appendChild(li);
            });
            var head = $('[data-dv-wishlist-changes-count]', changes);
            if (head) {
              var tpl = changed.length === 1 ? (strings.changed_one || '') : (strings.changed_other || '');
              head.textContent = tpl.replace('%COUNT%', String(changed.length));
            }
            show(changes, true);
          }

          show(grid, true);
          show(tools, true);
          paintTabs(counts, kept);
          Wishlist.render();
        })
        .catch(function () {
          show(loading, false);
          show(errorBox, true);
        });
    }

    page.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-dv-wishlist-remove]');
      if (remove) {
        Wishlist.remove(remove.getAttribute('data-dv-wishlist-remove'));
        Wishlist.render();
        load();
        return;
      }
      var tab = event.target.closest('[data-dv-wishlist-tab]');
      if (tab) {
        selectTab(tab.getAttribute('data-dv-wishlist-tab'));
        return;
      }
      if (event.target.closest('[data-dv-wishlist-clear]')) {
        Wishlist.clear();
        Wishlist.render();
        load();
      }
    });

    document.addEventListener('dv:wishlist:change', function () { load(); });

    load();
  }

  function boot() {
    Wishlist.render();
    initGate();
    initPage();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
